import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#14B8A6] rounded-t-3xl mx-10 mt-24">
      <div className="max-w-7xl mx-auto px-[5%] py-16">
        <div className="grid grid-cols-12 gap-12 mb-16">
          <div className="col-span-6">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/183f8cfb99a61f063094dcdb2d67a749/bd429f0e24d0f140c80be890f13f1a7b.png"
                alt="Global Pillar Limited"
                className="h-10 w-10 object-contain"
              />
              <h3 className="text-3xl font-bold text-white">Global Pillar Limited</h3>
            </div>
            <p className="text-sm text-white/80 mb-8">{t('footer.tagline')}</p>
            <p className="text-sm text-white/70 leading-relaxed">
              Delivering customized IT solutions to telecommunications, healthcare, education, and trade sectors across Hong Kong since 2022.
            </p>
          </div>

          <div className="col-span-2">
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-6">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              {[
                { key: 'home', label: t('nav.home') },
                { key: 'solutions', label: t('nav.solutions') },
                { key: 'process', label: t('nav.process') },
                { key: 'about', label: t('nav.about') },
                { key: 'contact', label: t('nav.contact') }
              ].map((item) => (
                <li key={item.key}>
                  <button
                    onClick={() => scrollToSection(item.key)}
                    className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-4">
            <h4 className="text-base font-semibold text-white mb-3">{t('footer.newsletter')}</h4>
            <p className="text-sm text-white/70 mb-4">{t('footer.newsletterDesc')}</p>
            <div className="flex items-center gap-2">
              <input
                type="email"
                placeholder={t('footer.emailPlaceholder')}
                className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-white/30 text-sm"
              />
              <button className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:bg-white/90 transition-colors cursor-pointer flex-shrink-0">
                <i className="ri-arrow-right-line text-[#14B8A6] text-xl"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex items-center justify-between">
          <p className="text-sm text-white/70">
            © 2024 Global Pillar Limited. {t('footer.rights')}.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white/70 hover:text-white transition-colors"
            >
              {t('footer.poweredBy')}
            </a>
            <a href="mailto:marketing@globalpillar.pro" className="text-white/70 hover:text-white transition-colors">
              <i className="ri-mail-line text-xl"></i>
            </a>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 overflow-hidden opacity-10 pointer-events-none">
          <div className="text-[180px] font-bold text-white/20 whitespace-nowrap select-none">
            GLOBAL PILLAR
          </div>
        </div>
      </div>
    </footer>
  );
}
